export default __webpack_public_path__ + "static/media/new-review.e197bf6b.mp4";